import Displaceable from 'displaceable'

const skewFactor = 0

const elements = [
  {
    selectors: [
      document.querySelector('.banner_image .oval'),
      document.querySelector('.banner_image .half-oval'),
      document.querySelector('.banner_image .triangle'),
      document.querySelector('.banner_image .trapezoid')
    ],
    options: {
      skewFactor,
      trigger: document.querySelector('.banner')
    }
  },
  {
    selectors: [document.querySelector('.about .displace_wrapper')],
    options: {
      skewFactor,
      trigger: document.querySelector('.about')
    }
  },
  {
    selectors: [document.querySelector('.portfolio .displace_wrapper')],
    options: {
      skewFactor,
      trigger: document.querySelector('.portfolio')
    }
  },
  {
    selectors: [document.querySelector('.services .displace_wrapper')],
    options: {
      skewFactor,
      trigger: document.querySelector('.services')
    }
  },
  {
    selectors: [document.querySelector('.specialities .displace_oval')],
    options: {
      skewFactor,
      trigger: document.querySelector('.specialities_wrapper')
    }
  },
  {
    selectors: [document.querySelector('.specialities .displace_trapezoid')],
    options: {
      skewFactor,
      trigger: document.querySelector('.specialities')
    }
  },
  {
    selectors: [document.querySelector('.testimonials .displace_rectangle')],
    options: {
      skewFactor,
      trigger: document.querySelector('.portfolio .container')
    }
  },
  {
    selectors: [document.querySelector('.testimonials .displace_half-oval')],
    options: {
      skewFactor,
      trigger: document.querySelector('.testimonials')
    }
  }
]

elements.forEach(element => {
  new Displaceable(element.selectors, element.options)
})